import React, { useEffect, useRef, useState } from "react";
import { SuperBlockContent } from "./super-block-content";

import "./stats.scss";
import classNames from "classnames";

interface Props {
  bodyA: string;
  bodyB: string;
  bodyC: string;
}

export const Stats = ({ bodyA, bodyB, bodyC }: Props) => {
  return (
    <div className="stats-wrapper">
      <div>
        <SuperBlockContent
          projectId={"g3so7nt7"}
          dataset={"production"}
          className={classNames("stats-body")}
          blocks={bodyA}
        />
      </div>
      <div>
        <SuperBlockContent
          projectId={"g3so7nt7"}
          dataset={"production"}
          className={classNames("stats-body")}
          blocks={bodyB}
        />
      </div>
      <div>
        <SuperBlockContent
          projectId={"g3so7nt7"}
          dataset={"production"}
          className={classNames("stats-body")}
          blocks={bodyC}
        />
      </div>
    </div>
  );
};
